/* Afkar Plus - spin-reward reservation + cart strip (BeyondADS 24 Sep 2026), same mechanism as 8trackfit tf-offer.js:
   - a spin win writes a 15-minute reservation {code, prize, note, until} (localStorage "afkarSpinRes")
   - the engine puts the code in the cart with POST /cart/update.js {discount}, re-reading the cart right before every write
     and KEEPING every code the shopper typed themselves (only codes starting "SPIN" are ours)
   - a red strip in the cart drawer (Opus app, open shadow root) and on /cart counts down m:ss.cs (rAF + tick fallback)
   - when the time runs out the reservation is purged and our code is removed from the cart again (real, not cosmetic)
   - the free surprise gift ($35+, added by the cart app) gets a strip too, WITHOUT a countdown: it is a standing offer. */
(function () {
  'use strict';
  if (window.__aofLoaded) return; window.__aofLoaded = true;
  var KEY = 'afkarSpinRes', HOLD = 15 * 60 * 1000;
  var res = null, deadline = 0, cart = null, busy = false, pending = false, lastSig = '';
  var gift = false;
  var MIN = { SPIN15: 2500, SPIN20: 4000, SPIN5OFF: 2000 }; /* cents, same minimums as the real codes */

  function load() { try { res = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { res = null; } deadline = res && res.until ? res.until : 0; }
  function save(v) { try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); } catch (e) {} load(); }
  function live() { return !!(res && res.code && deadline > Date.now()); }
  function isOurs(code) { return /^SPIN/i.test(code || ''); }
  function j(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- discount sync ---------- */
  function sync(force) {
    if (busy) { pending = true; return Promise.resolve(); }
    busy = true;
    return j('/cart.js').then(function (c) {
      cart = c; readGift();
      var have = (c.discount_codes || []).map(function (d) { return d.code; });
      var foreign = have.filter(function (x) { return !isOurs(x); });
      var mine = have.filter(isOurs);
      var want = live() ? [res.code] : [];
      var same = mine.length === want.length && mine.every(function (x, i) { return x.toUpperCase() === String(want[i]).toUpperCase(); });
      if (same && !force) return c;
      return j('/cart/update.js', { discount: foreign.concat(want).join(',') }).then(function (c2) {
        cart = c2; readGift();
        document.dispatchEvent(new CustomEvent('afkar:cart:updated', { detail: { source: 'offer' } }));
        return c2;
      });
    }).catch(function () {}).then(function () {
      busy = false; paint();
      if (pending) { pending = false; sync(); }
    });
  }

  function readGift() {
    gift = !!(cart && (cart.items || []).some(function (it) { return /free-surprise-gift/i.test(it.handle || '') || /free surprise gift/i.test(it.product_title || it.title || ''); }));
  }

  /* ---------- strip ---------- */
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3.5-5-1.2C7 7.2 9.5 7 12 7zm0 0c1.5-3 5-3.5 5-1.2C17 7.2 14.5 7 12 7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  function stripHTML() {
    return '<div class="aof-strip" data-aof-strip hidden>' +
      '<span class="aof-ico">' + ICON + '</span>' +
      '<p class="aof-msg" data-aof-msg></p>' +
      '<span class="aof-time" data-aof-time></span>' +
      '<a class="aof-btn" href="/collections/all" data-aof-btn>Shop now</a>' +
      '</div>';
  }
  var CSS = '.aof-strip{display:flex;align-items:center;gap:10px;margin:10px 12px 4px;padding:11px 12px;border-radius:12px;background:#e31c63;color:#fff;font-family:"Instrument Sans",sans-serif;box-shadow:0 8px 22px rgba(227,28,99,.28);animation:aof-in .35s ease both}' +
    '.aof-strip[hidden]{display:none!important}' +
    '.aof-strip.is-gift{background:#111}' +
    '@keyframes aof-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}' +
    '.aof-ico{flex:0 0 20px;width:20px;height:20px;color:#fff}.aof-ico svg{width:100%;height:100%}' +
    '.aof-msg{flex:1 1 auto;min-width:0;margin:0;font-size:12.5px!important;line-height:1.35;font-weight:500;color:#fff!important}.aof-msg b{font-weight:800;color:#fff!important}' +
    '.aof-time{flex:0 0 auto;min-width:6.4ch;text-align:right;font-size:15px!important;font-weight:800!important;font-variant-numeric:tabular-nums;letter-spacing:.02em;color:#fff!important}' +
    '.aof-time:empty{display:none}' +
    '.aof-btn{flex:0 0 auto;padding:6px 10px;border-radius:999px;background:#fff!important;color:#e31c63!important;font-size:9.5px!important;font-weight:800!important;letter-spacing:.06em;text-transform:uppercase;text-decoration:none!important;white-space:nowrap;line-height:1.2}' +
    '.aof-strip.is-gift .aof-btn{color:#111!important}.aof-strip,.aof-strip *{color:#fff}' +
    '@media (max-width:480px){.aof-strip{flex-wrap:wrap;gap:8px 10px}.aof-msg{flex-basis:calc(100% - 34px)}.aof-time{margin-left:32px;text-align:left}.aof-btn{margin-left:auto}}';

  var strips = [];
  function mount(parent, before) {
    if (!parent) return null;
    var host = document.createElement('div'); host.innerHTML = stripHTML();
    var el = host.firstChild;
    parent.insertBefore(el, before || parent.firstChild);
    strips.push(el); lastSig = ''; return el;
  }
  function ensureDrawer() {
    var hostEl = document.getElementById('opus-shadow-container');
    var sr = hostEl && hostEl.shadowRoot; if (!sr) return;
    if (!sr.getElementById('aof-style')) { var st = document.createElement('style'); st.id = 'aof-style'; st.textContent = CSS; sr.appendChild(st); }
    var header = sr.querySelector('.opus-drawer-container-header');
    if (!header || !header.parentNode) return;
    var next = header.nextElementSibling;
    if (next && next.hasAttribute && next.hasAttribute('data-aof-strip')) return;
    var old = sr.querySelector('[data-aof-strip]'); if (old) { strips = strips.filter(function (s) { return s !== old; }); old.remove(); }
    mount(header.parentNode, header.nextSibling);
  }
  function ensurePage() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    if (document.querySelector('[data-aof-strip]')) return;
    if (!document.getElementById('aof-style')) { var st = document.createElement('style'); st.id = 'aof-style'; st.textContent = CSS + '.aof-strip--page{max-width:1100px;margin:18px auto 0}'; document.head.appendChild(st); }
    var main = document.querySelector('#MainContent');
    var el = mount(main, main && main.firstChild); if (el) el.classList.add('aof-strip--page');
  }

  function paint() {
    strips = strips.filter(function (s) { return s.isConnected; });
    var on = live(), sig;
    var st = on ? state() : null;
    if (on) sig = 'res|' + res.code + '|' + st.kind + '|' + st.left;
    else if (gift) sig = 'gift';
    else sig = 'none';
    if (sig === lastSig) return;
    lastSig = sig;
    strips.forEach(function (s) {
      var msg = s.querySelector('[data-aof-msg]'), t = s.querySelector('[data-aof-time]');
      s.classList.toggle('is-gift', !on && gift);
      if (on) {
        msg.innerHTML = st.kind === 'short' ? 'Add <b>' + money(st.left) + '</b> more to get <b>' + esc(res.prize) + '</b>.'
          : st.kind === 'on' ? '<b>' + esc(res.prize) + '</b> applied.' : '<b>' + esc(res.prize) + '</b> saved.';
        s.hidden = false;
      } else if (gift) {
        msg.innerHTML = '<b>Free surprise gift</b> added to your order.';
        t.textContent = ''; s.hidden = false;
      } else { s.hidden = true; t.textContent = ''; }
    });
    writeClock();
  }
  /* is the code really working on this bag? read it from the cart, not from our own copy */
  function state() {
    var sub = cart ? (cart.items_subtotal_price || 0) : 0, min = MIN[String(res.code).toUpperCase()] || 0;
    if (min && sub < min) return { kind: 'short', left: min - sub };
    var dc = cart && (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === String(res.code).toUpperCase(); })[0];
    return { kind: dc && dc.applicable ? 'on' : 'saved', left: 0 };
  }
  function money(c) { var v = (c / 100).toFixed(2); return '$' + (/\.00$/.test(v) ? v.slice(0, -3) : v); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- clock: m:ss.cs, textContent only when it changes ---------- */
  var lastClock = '';
  function fmt(ms) {
    ms = Math.max(0, ms);
    var m = Math.floor(ms / 60000), s = Math.floor(ms / 1000) % 60, cs = Math.floor(ms / 10) % 100;
    return m + ':' + (s < 10 ? '0' : '') + s + '.' + (cs < 10 ? '0' : '') + cs;
  }
  function writeClock() {
    if (!live()) return;
    var str = fmt(deadline - Date.now());
    if (str === lastClock && strips.every(function (s) { return s.querySelector('[data-aof-time]').textContent === str; })) return;
    lastClock = str;
    strips.forEach(function (s) { var t = s.querySelector('[data-aof-time]'); if (t.textContent !== str) t.textContent = str; });
  }
  function frame() { writeClock(); requestAnimationFrame(frame); }

  /* ---------- tick: expiry + keeping the strip mounted (rAF does not run in background tabs) ---------- */
  function tick() {
    ensureDrawer(); ensurePage();
    if (res && res.code && deadline && deadline <= Date.now()) { save(null); lastSig = ''; sync(true); }
    writeClock(); paint();
  }

  /* ---------- claims from the spin popup ---------- */
  function claim(detail) {
    if (!detail || !detail.code) return;
    save({ code: String(detail.code).toUpperCase(), prize: detail.prize || '', note: detail.note || '', until: Date.now() + HOLD });
    lastSig = ''; sync(true);
  }
  window.afkarOffer = { claim: claim, sync: sync };
  document.addEventListener('afkar:spin:won', function (e) { claim(e.detail); });
  document.addEventListener('afkar:cart:updated', function (e) { if (!(e.detail && e.detail.source === 'offer')) setTimeout(function () { sync(); }, 300); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { load(); lastSig = ''; sync(); } });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { load(); lastSig = ''; sync(); } });
  /* any fetch to the cart endpoints made by the theme or the cart app re-checks the gift + our code */
  if (window.fetch && !window.fetch.__aof) {
    var of = window.fetch;
    var wrapped = function (input, init) {
      var p = of.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(u) && !(init && init.body && /"discount"/.test(String(init.body)))) p.then(function () { setTimeout(function () { sync(); }, 400); });
      } catch (e) {}
      return p;
    };
    wrapped.__aof = true; window.fetch = wrapped;
  }

  function boot() {
    load(); ensureDrawer(); ensurePage(); sync();
    setInterval(tick, 250);
    requestAnimationFrame(frame);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
